(function () {
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sabaskin-purchase-option]')) return;

    var wrapper = e.target.closest('.sabaskin-purchase-options');
    if (!wrapper) return;

    var qty = e.target.value;
    var form = e.target.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    wrapper.querySelectorAll('.sabaskin-purchase-option').forEach(function (card) {
      card.classList.toggle('sabaskin-purchase-option--selected', card.contains(e.target));
    });
  });
})();